import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Divider
} from '@mui/material';

interface ImportError {
  row: number;
  column: string;
  message: string;
}

interface ImportErrorModalProps {
  open: boolean;
  onClose: () => void;
  errors: ImportError[];
}

const ImportErrorModal: React.FC<ImportErrorModalProps> = ({ open, onClose, errors }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ color: 'error.main' }}>שגיאות בייבוא הנתונים</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          נמצאו שגיאות המונעות את הייבוא. אנא תקן את הקובץ ונסה שוב:
        </Typography>
        <Divider sx={{ my: 2 }} />
        <List sx={{ maxHeight: '400px', overflow: 'auto' }}>
          {errors.map((error, index) => (
            <ListItem key={index} divider>
              <ListItemText
                primary={
                  <Box component="span" sx={{ fontWeight: 'bold' }}>
                    שורה {error.row}: עמודה '{error.column}'
                  </Box>
                }
                secondary={error.message}
                secondaryTypographyProps={{ color: 'error' }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">סגור</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportErrorModal;
